module.exports = __webpack_public_path__ + "static/img/beta_bg_09.34f917a3.svg";